import { ContactSourceEnum } from '../../../enums/contact-source.enum';
import { ContactTitleEnum } from '../../../enums/contact-title.enum';
import { ProtoContactTypeEnum } from '../../../../proto/contacts/enums/proto-contact-type.enum';

/**
 * Applies create-path defaults for proto-owned contacts.
 */
export function applyProtoContactCreateDefaults<
  T extends {
    type?: ProtoContactTypeEnum | null;
    source?: ContactSourceEnum | null;
    title?: ContactTitleEnum | null;
  },
>(contact: T): T {
  contact.type = contact.type ?? ProtoContactTypeEnum.GUEST;
  contact.source = contact.source ?? ContactSourceEnum.BROKER;
  contact.title = contact.title ?? ContactTitleEnum.NONE;

  return contact;
}
